import { useTranslations } from "next-intl";
import { Request } from "../apis/types";

const createPersonString = (
  t: ReturnType<typeof useTranslations>,
  totalOccupants: number
) => {
  if (totalOccupants === 1) {
    return t("Other.onePerson");
  }

  return t("Other.manyPersons", { totalOccupants });
};

const createNightString = (
  t: ReturnType<typeof useTranslations>,
  numberOfNights: number
) => {
  if (numberOfNights === 1) {
    return t("Other.oneNight");
  }

  return t("Other.manyNights", { numberOfNights });
};

export default function determineRoomOccupancy(
  t: ReturnType<typeof useTranslations>,
  request: Request
): string {
  const { numberOfAdults, numberOfChildren, numberOfInfants, from, to } =
    request;
  const totalOccupants =
    Number(numberOfAdults) + Number(numberOfChildren) + Number(numberOfInfants);

  const fromDate = new Date(from);
  const toDate = new Date(to);

  const differenceInTime = toDate.getTime() - fromDate.getTime();
  const numberOfNights = differenceInTime / (1000 * 3600 * 24);

  return `${createPersonString(t, totalOccupants)}, ${createNightString(t, numberOfNights)}`;
}
